import { useEffect, useState } from "react";

const otp_expiry_key = "otp_resend_expiry";
const resend_seconds = 120;

const getRemainingFromStorage = (): number => {
  const expiry = sessionStorage.getItem(otp_expiry_key);
  if (!expiry) return 0;
  const remaining = Math.ceil((parseInt(expiry) - Date.now()) / 1000);
  return Math.max(0, remaining);
};

const useOtpCountdown = () => {
  const [resendCountdown, setResendCountdown] = useState<number>(0);

  useEffect(() => {
    setResendCountdown(getRemainingFromStorage());
  }, []);

  const startCountdown = () => {
    const expiryTime = Date.now() + resend_seconds * 1000;
    sessionStorage.setItem(otp_expiry_key, expiryTime.toString());
    setResendCountdown(resend_seconds);
  };

  const clearExpiry = () => {
    sessionStorage.removeItem(otp_expiry_key);
  };

  useEffect(() => {
    if (resendCountdown <= 0) {
      clearExpiry();
      return;
    }

    const timer = window.setTimeout(() => {
      setResendCountdown(getRemainingFromStorage());
    }, 1000);

    return () => window.clearTimeout(timer);
  }, [resendCountdown]);

  return { resendCountdown, startCountdown };
};

export default useOtpCountdown;
